import { Breadcrumb, IBreadcrumbProps } from '@fluentui/react';
import React from 'react';

export const EHBreadcrumb = (props: IBreadcrumbProps): JSX.Element => <Breadcrumb {...props} />;
